import axios from 'axios'

const ROUTE = '/rest/v4/devices';

export default {

  loadData(id) {
    return axios.get(`${ROUTE}/${id}`);
  },

  loadSimpleData(id) {
    return axios.get(`${ROUTE}/${id}/short`);
  },

  post(data) {
    return axios.post(ROUTE, data);
  },

  put(id, data) {
    return axios.put(`${ROUTE}/${id}`, data);
  },

  getImage(id) {
    return axios.get(`${ROUTE}/${id}/image`)
  },

  copyContact(id, data){
    return axios.post(`${ROUTE}/${id}/copycontact`, data);
},
}
